import { Button } from '../ui/button';
import { Archive, Trash2, RotateCcw, Mail } from 'lucide-react';

export function BulkActionBar({
  activeTab,
  bulkEligibleCount,
  filteredCount,
  filteredIncludesAdmins,
  onArchive, onDelete, onRestore, onPermanentDelete, onEmail,
}) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-muted/60 border border-border" data-testid="bulk-action-bar">
      <span className="text-xs font-medium text-foreground mr-2">
        {bulkEligibleCount} user{bulkEligibleCount !== 1 ? 's' : ''} matched
      </span>
      {activeTab === 'active' && (
        <>
          {!filteredIncludesAdmins && (
            <>
              <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onArchive} data-testid="bulk-archive-btn">
                <Archive className="w-3.5 h-3.5 mr-1.5" /> Archive All
              </Button>
              <Button
                variant="outline" size="sm"
                className="h-7 text-xs text-destructive border-destructive/30 hover:bg-destructive/10"
                onClick={onDelete} data-testid="bulk-delete-btn"
              >
                <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Delete All
              </Button>
            </>
          )}
          <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onEmail} data-testid="bulk-email-btn">
            <Mail className="w-3.5 h-3.5 mr-1.5" /> Email All ({filteredCount})
          </Button>
        </>
      )}
      {activeTab === 'archived' && (
        <>
          <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onRestore} data-testid="bulk-restore-btn">
            <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Restore All
          </Button>
          <Button
            variant="outline" size="sm"
            className="h-7 text-xs text-destructive border-destructive/30 hover:bg-destructive/10"
            onClick={onDelete} data-testid="bulk-delete-btn"
          >
            <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Delete All
          </Button>
          <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onEmail} data-testid="bulk-email-btn">
            <Mail className="w-3.5 h-3.5 mr-1.5" /> Email All ({filteredCount})
          </Button>
        </>
      )}
      {activeTab === 'deleted' && (
        <>
          <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onRestore} data-testid="bulk-restore-btn">
            <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Restore All
          </Button>
          <Button
            variant="outline" size="sm"
            className="h-7 text-xs text-destructive border-destructive/30 hover:bg-destructive/10"
            onClick={onPermanentDelete} data-testid="bulk-perm-delete-btn"
          >
            <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Permanently Delete All
          </Button>
        </>
      )}
    </div>
  );
}
